import { useEffect } from 'react';
import { prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { IFormConfig } from 'js/components/common/Form/types';
import { useAppSelector, useFormsSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { workerService } from 'js/services/worker.service';

import * as actions from './store/actions';

export const useGetForms = () => {
    const dispatch = useDispatch();
    const getCMSResourceURL = useGetCMSResourceURL();
    const requestStamp = useAppSelector(prop('requestStamp'));
    const isFormsLoaded = useFormsSelector(prop('isFormsLoaded'));

    useEffect(() => {
        if (isFormsLoaded) {
            return;
        }

        const requestURL = getCMSResourceURL('/initialResources/forms', { t: requestStamp || Date.now() });

        workerService.request<string, IFormConfig[]>('forms', requestURL)
            .then((forms) => {
                const formsData = {
                    isFormsLoaded: true,
                    forms
                };

                dispatcher.dispatch('forms:data', formsData);
                dispatch(actions.updateFormsData(formsData));
            });
    }, [getCMSResourceURL, requestStamp, dispatch, isFormsLoaded]);
};
